﻿require('../../libs/backbone/backbone.ajaxq.adapter.ts');
var NavBarSideView = require('../views/navbar_side.view.ts');
var NavBarTopView = require('../views/navbar_top.view.ts');
var ProgressTemplate = require('text-loader!../../js/templates/progress.template.htm');
require('dhtmlxMessage');
var i18n = require("l10n");

var LoginView = require("../views/login.view.ts");
var ForgotPasswordView = require("../views/forgot_password.view.ts");
var ResetPasswordView = require("../views/reset_password.view.ts"); // testing
var DashboardView = require("../views/dashboard.view.ts");
var VenuesView = require("../views/venues.view.ts");
var VenueView = require("../views/venue.view.ts");
var AccountView = require("../views/account.view.ts");
var QueuesView = require("../views/queues.view.ts");
var QueueView = require("../views/queue.view.ts");
var AnalyticsView = require("../views/analytics.view.ts");
var UsersView = require("../views/users.view.ts");
var UserView = require("../views/user.view.ts");
var OrganizationsView = require("../views/organizations.view.ts");
var OrganizationView = require("../views/organization.view.ts");
var MonitorView = require("../views/monitors/monitor.view.ts");
var QueueMonitorView = require("../views/monitors/queue_monitor.view.ts");
var QueuesMonitorView = require("../views/queues_monitor.view.ts");
var AgentQueuesView = require("../views/agent_queues.view.ts");
var CounterMonitorView = require("../views/counter_monitor.view.ts");
var TicketsView = require("../views/tickets/tickets.view.ts");
var PreparationsView = require("../views/preparations/preparations.view.ts");
var LoginsView = require("../views/logins.view.ts");
var SettingsView = require("../views/settings.view.ts");
var IssueTicketView = require("../views/checkin/issueTicket.view.ts");
var KiosksView = require("../views/kiosks.view.ts");
var KioskView = require("../views/kiosk.view.ts");
var PatientsView = require("../views/patients.view.ts");
var PatientView = require("../views/patient.view.ts");

var TheRouter = Backbone.Router.extend({
	routes: {
		"": "defaultRoute",
		"Login": "loginRoute",
		"ForgotPassword": "forgotPasswordRoute",
		"ResetPassword": "resetPasswordRoute",
		"Dashboard": "dashboardRoute",
		"Venues": "venuesRoute",
		"Venue(/:id)": "venueRoute",
		"Account": "accountRoute",
		"Queues": "queuesRoute",
		"Queue(/:id)": "queueRoute",
		"Analytics": "analyticsRoute",
		"Users": "usersRoute",
		"User(/:id)": "userRoute",
		"Organizations" : "organizationsRoute",
		"Organization(/:id)" : "organizationRoute",
		// "QueueMonitor(/:id)": "queueMonitorRoute",
		// "QueuesMonitor": "queuesMonitorRoute",
		"AgentQueues": "agentQueuesRoute",
		"CounterMonitor": "counterMonitorRoute",
		"Tickets": "ticketsRoute",
		"CheckIn": "issueTicketRoute",
		"Preparations": "preparationsRoute",
		"Logins": "loginsRoute",
		"Settings": "settingsRoute",
		// "Kiosks": "kiosksRoute",
		// "Kiosk(/:id)": "kioskRoute",
		// "Patients": "patientsRoute",
		// "Patient(/:id)": "patientRoute",
		"Registrations": "patientsRoute",
		"Registration(/:id)": "patientRoute",
	},
	loggedIn: false,
	progressTemplate : Handlebars.compile(ProgressTemplate),
	token: null,
	userData: null,
	orgData: null,
	initialize: function (options) {
		self = this;
		this.loggedIn = options.loggedIn;
		this.token = options.token;
		if(options.data)
		{
			if( options.data.org)
			{
				this.userData = options.data.user;
				this.orgData = options.data.org;
			}
			else
			{
				this.userData = options.data;
			}
		}


		if(this.loggedIn){
			$.ajaxSetup({
				beforeSend: function (xhr) {
				//xhr.setRequestHeader('Authorization', "Bearer " + self.token);
				    xhr.setRequestHeader('systemTime', new Date().getTime());
				},
				error: function (xhr, exception) {
					//console.info("ERROR at AJAX ROUTER");
					document.cookie = "status=" + xhr.status;
					if (xhr.status == 401) {
						window.open('./','_self');
					}else if(xhr.status == 403){
						$.ajaxq.abort("DefaultQueue");
						window.open('./','_self');
					}
				}
			});

		}

		//console.info("status "+$('body').getCookie("status"));
		if($('body').getCookie("status") == 401)
			$.notify("Token has expired", { position:"top left", className: "error"});
		else if($('body').getCookie("status") == 403)
			$.notify("This action is not permitted", { position:"top left", className: "error"});

		document.cookie = "status=0";

	},
	defaultRoute: function () {
		if(!this.loggedIn){
			this.navigate('Login', {trigger: true});
		}else
		{
			if(this.userData.privilegeLevel == "VenueAgent")
				this.navigate('AgentQueues', {trigger: true});
			else
				this.navigate('Dashboard', {trigger: true});
		}

	},
	loginRoute: function(logged){
		var self = this;
		if(this.loggedIn)
		{
			this.navigate("", {trigger: true});
			return;
		}
		this.clearView();

		this.view = new LoginView();

		this.changeTitle(i18n.t('pageHeader.login'));
	},
	settingsRoute: function(){
        var self = this;
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();

        var pageHeader = "settings";

        this.createTheNavBars(pageHeader);

        this.view = new SettingsView({ data: this.userData });

        this.changeTitle(i18n.t('pageHeader.settings'));
        this.showActiveMenuItem($('[href="#Settings"]'));
    },
	forgotPasswordRoute: function() {
	    var self = this;

	    this.clearView();

	    this.view = new ForgotPasswordView();

	    this.changeTitle(i18n.t('account.forgotten_password'));
	},
	resetPasswordRoute: function() {
	    var self = this;

        this.clearView();

        this.view = new ResetPasswordView();

        this.changeTitle(i18n.t('account.reset_pswd'));
	},
	dashboardRoute: function () {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		this.createTheNavBars("dashboard");
		this.view = new DashboardView({data: this.userData});

		this.changeTitle(i18n.t('pageHeader.dashboard'));
		this.showActiveMenuItem($('[href="#Dashboard"]'));
	},
	venuesRoute: function(){
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		this.createTheNavBars("venues");
		this.view = new VenuesView();

		this.changeTitle(i18n.t('pageHeader.venues'));
		this.showActiveMenuItem($('[href="#Venues"]'));
	},
	venueRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();
        //geHeader = "venue";
        var pageHeader = "venue";
		if(!id)
			pageHeader = "venue"

		this.createTheNavBars(pageHeader);

        this.view = new VenueView({ id : id, data: this.userData  });

        this.changeTitle(i18n.t('pageHeader.venue'));
        this.showActiveMenuItem($('[href="#Venues"]'));
    },
	accountRoute: function () {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		this.createTheNavBars("account_profile");

		this.view = new AccountView({data: this.userData});

		this.changeTitle(i18n.t('pageHeader.account_profile'));
		this.showActiveMenuItem(null);
	},
	queuesRoute: function()
	{
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		this.createTheNavBars("queues");
		this.view = new QueuesView({ data: this.userData });

		this.changeTitle(i18n.t('pageHeader.queues'));
		this.showActiveMenuItem($('[href="#Queues"]'));
	},
	queueRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();
        //this.pageHeader = "queue";
        var pageHeader = "queue";
		if(!id)
			pageHeader = "queue"

		this.createTheNavBars(pageHeader);

        this.view = new QueueView({ id : id, data: this.userData });

        this.changeTitle(i18n.t('pageHeader.queue'));
        this.showActiveMenuItem($('[href="#Queues"]'));
    },
	kiosksRoute: function()
	{
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		this.createTheNavBars("kiosks");
		this.view = new KiosksView({ data: this.userData });

		this.changeTitle(i18n.t('pageHeader.kiosks'));
		this.showActiveMenuItem($('[href="#Kiosks"]'));
	},
	kioskRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();

        var pageHeader = "kiosk";

		this.createTheNavBars(pageHeader);

        this.view = new KioskView({ id : id, data: this.userData });

        this.changeTitle(i18n.t('pageHeader.kiosk'));
        this.showActiveMenuItem($('[href="#Kiosks"]'));
    },
	patientsRoute: function()
	{
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		// this.createTheNavBars("patients");
		this.createTheNavBars("registrations");
		this.view = new PatientsView({ data: this.userData });

		// this.changeTitle(i18n.t('pageHeader.patients'));
		// this.showActiveMenuItem($('[href="#Patients"]'));
		this.changeTitle(i18n.t('pageHeader.registrations'));
		this.showActiveMenuItem($('[href="#Registrations"]'));
	},
	patientRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();

        // var pageHeader = "patient";
        var pageHeader = "registration";

		this.createTheNavBars(pageHeader);

        this.view = new PatientView({ id : id, data: this.userData });

        // this.changeTitle(i18n.t('pageHeader.patient'));
        // this.showActiveMenuItem($('[href="#Patients"]'));
		this.changeTitle(i18n.t('pageHeader.registration'));
        this.showActiveMenuItem($('[href="#Registrations"]'));
    },
	analyticsRoute: function() {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();
        this.createTheNavBars("analytics");

        this.view = new AnalyticsView();

		this.changeTitle(i18n.t('pageHeader.analytics'));
        this.showActiveMenuItem($('[href="#Analytics"]'));
    },
    usersRoute: function() {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();
        this.createTheNavBars("users");

        this.view = new UsersView();

		this.changeTitle(i18n.t('pageHeader.users'));
        this.showActiveMenuItem($('[href="#Users"]'));
    },
    userRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();
        //this.pageHeader = "user";
        var pageHeader = "user";

		if(!id)
			pageHeader = "user"

		this.createTheNavBars(pageHeader);

        this.view = new UserView({ id : id, data: this.userData });

		this.changeTitle(i18n.t('pageHeader.user'));
        this.showActiveMenuItem($('[href="#Users"]'));
    },
    organizationsRoute: function () {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();
        this.createTheNavBars("organizations");

        this.view = new OrganizationsView();

		this.changeTitle(i18n.t('pageHeader.organizations'));
        this.showActiveMenuItem($('[href="#Organizations"]'));
    },
    organizationRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();
        //this.pageHeader = "organization";
        var pageHeader = "organization";

        if(!id)
        	pageHeader = "organization"

        this.createTheNavBars(pageHeader);

        this.view = new OrganizationView({ id : id });

		this.changeTitle(i18n.t('pageHeader.organization'));
        this.showActiveMenuItem($('[href="#Organizations"]'));
    },
    queueMonitorRoute: function(id) {
        var ids = id.split(",").map(id => parseInt(id));
        this.clearView();

        this.view = new MonitorView({queueIds: ids});

		this.changeTitle(i18n.t('pageHeader.queue_monitor'));
    },
    queuesMonitorRoute: function() {
        if(!this.loggedIn) {
            window.open('./','_self');
            return;
        }
        this.clearView();
        this.createTheNavBars("queues_monitor");

        this.view = new QueuesMonitorView();

		this.changeTitle(i18n.t('pageHeader.queues_monitor'));
        this.showActiveMenuItem($('[href="#QueuesMonitor"]'));
    },
    agentQueuesRoute: function()
    {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		this.createTheNavBars("my_queues");

		this.view = new AgentQueuesView({  data: this.userData });

		this.changeTitle(i18n.t('pageHeader.my_queues'));
		this.showActiveMenuItem($('[href="#AgentQueues"]'));
    },
    counterMonitorRoute: function()
    {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.clearView();
		this.createTheNavBars("counter_monitor");

		this.view = new CounterMonitorView({  data: this.userData });

		this.changeTitle(i18n.t('pageHeader.counter_monitor'));
		this.showActiveMenuItem($('[href="#AgentQueues"]'));
    },
    ticketsRoute: function(){
        var self = this;
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();

        var pageHeader = "tickets";

        this.createTheNavBars(pageHeader);

        this.view = new TicketsView({"userData": this.userData});

        this.changeTitle(i18n.t('pageHeader.tickets'));
        this.showActiveMenuItem($('[href="#Tickets"]'));
    },
    preparationsRoute: function(){
        var self = this;
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();

        var pageHeader = "preparations";

        this.createTheNavBars(pageHeader);

        this.view = new PreparationsView();

        this.changeTitle(i18n.t('pageHeader.preparations'));
        this.showActiveMenuItem($('[href="#Preparations"]'));
    },
    issueTicketRoute: function(){
        var self = this;
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.clearView();

        var pageHeader = "checkIn";

        this.createTheNavBars(pageHeader);

        this.view = new IssueTicketView({"userData": this.userData});

        this.changeTitle(i18n.t('pageHeader.checkIn'));
        this.showActiveMenuItem($('[href="#CheckIn"]'));
    },
    loginsRoute: function(){
		var self = this;
		if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
		this.clearView();

		var pageHeader = "logins";

        this.createTheNavBars(pageHeader);

		this.view = new LoginsView();

        this.changeTitle(i18n.t('pageHeader.logins'));
        this.showActiveMenuItem($('[href="#Logins"]'));
	},
	renderBaseView: function(baseTemplate){
		var View = ViewFactory(baseTemplate);
		this.view = new View(ViewConfiguration);
		this.view.render();
	},
	createTheNavBars: function(pageHeader)
	{
		window.progressBarCounter = 0;
		this.navbarside = new NavBarSideView({ data: this.userData });
		this.navbartop = new NavBarTopView({ data: this.userData, org: this.orgData, pageHeader: pageHeader });
	},
	clearView: function(){
		$("#general-progress").hideProgressBar();

		if(this.view){
			$.ajaxq.abort("DefaultQueue");
			this.view.stopListening();
			this.view.$el.empty();
			if(this.view.clearView)
				this.view.clearView();
			this.view.undelegateEvents();
			delete this.view;
			$("#container").html(this.progressTemplate());
			$("body").scrollTop(0);
		}

		if(this.navbartop) {
  			this.navbartop.stopListening();
			this.navbartop.undelegateEvents();
			this.navbartop.$el.empty();
			delete this.navbartop.source;
		}

		if(this.navbarside) {
  			this.navbarside.stopListening();
			this.navbarside.undelegateEvents();
			this.navbarside.$el.empty();
			delete this.navbarside.source;
		}
	},
	changeTitle: function(title)
	{
		var organization = "";
		if(this.orgData)
			organization = " - "+this.orgData.name;
		document.title = title+" | Regency Casino"+organization;
	},
	showActiveMenuItem: function(element)
	{
		if(element)
		{
			$("#main-menu").find(".active-menu").removeClass("active-menu");
			element.parent().addClass("active-menu");
		}
		else
		{
			$("#main-menu").find(".active-menu").removeClass("active-menu");
		}
	}
});

module.exports = TheRouter;